import Mainvisual from './top/_mainvisual';
import News from './top/_news';
//import Product from './top/_product';
//import Accordion from './top/_accordion';

const mainvisual = new Mainvisual();
const news = new News();
//const Product = new Accordion();
//const accordion = new Accordion();